(function () {

// Animation on Scroll
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const animation = entry.target.dataset.animation;
    console.log(animation, entry);
    (entry.isIntersecting) ?
      entry.target.classList.add(animation) :
      entry.target.classList.remove(animation);
  });
}, {threshold: 0.5});

document.querySelectorAll('[data-animation]').forEach(intersect => observer.observe(intersect));

const animationWithOptions = (item, opts) => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const animation = entry.target.dataset.animationOpts;
      (entry.isIntersecting) ?
        entry.target.classList.add(animation) :
        entry.target.classList.remove(animation);
    });
  }, opts);

  observer.observe(item);
}
document.querySelectorAll('[data-animation-opts]').forEach(item => {
  const options = {
    threshold: item.dataset.threshold ?? 0.5,
    rootMargin: item.dataset.rootMargin ?? '0%'
  };

  if(window.innerWidth < 768) {
    options.threshold = 0;
    options.rootMargin = '-50%';
  }

  // adjust options for mobile also take resize into account
  window.addEventListener('resize', () => {
    if(window.innerWidth < 768) {
      options.threshold = 0;
      options.rootMargin = '-50%';
    }
  });

  animationWithOptions(item, options);

});
// Select all elements with the class "sticky"
const stickyElements = document.querySelectorAll(".sticky");

const handleIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    const { target, isIntersecting } = entry;
    const dataset = target.dataset.scrollOpacityAnimation;

    if (isIntersecting && dataset === "centered") {
      target.style.opacity = "1";
    } else if (!isIntersecting && dataset === "centered") {
      target.style.opacity = "0";
    }
  });
};

const scrollOpacityObserver = new IntersectionObserver(handleIntersection, {
  threshold: 0,
});

stickyElements.forEach((element) => {
  scrollOpacityObserver.observe(element);
});

let lastScroll = 0;

window.addEventListener("scroll", () => {
  if(window.innerWidth >= 991) {
    const currentScroll = window.pageYOffset;

    stickyElements.forEach((element) => {
      const parentRect = element.parentNode.getBoundingClientRect();
      const { top, bottom } = element.getBoundingClientRect();
      const dataset = element.dataset.scrollOpacityAnimation;

      if (currentScroll < lastScroll) {
        // Scrolling up / Top to bottom
        if (dataset === "centered" && top <= parentRect.top + parentRect.height * 0.5) {
          element.style.opacity = "1";
        } else {
          const distanceFromTop = Math.max(parentRect.top + parentRect.height * 0.5 - top, 0);
          const opacity = 1 - distanceFromTop / (parentRect.height * 0.5); // 50% of parent height
          element.style.opacity = Math.max(opacity, 0);
        }
      } else {
        // Scrolling down / Bottom to top
        if (dataset === "centered" && bottom >= parentRect.top + parentRect.height * 0.5) {
          element.style.opacity = "1";
        } else {
          const distanceFromBottom = Math.max(bottom - (parentRect.top + parentRect.height * 0.5), 0);
          const triggerOffset = parentRect.height * 0.5; // Bottom 50% of parent height
          const opacity = distanceFromBottom / triggerOffset; // Opacity from 0 to 1
          element.style.opacity = Math.max(1 - opacity, 0); // Reverse opacity from 1 to 0
        }
      }
    });

    lastScroll = currentScroll;
  } else {
    stickyElements.forEach((element) => {
      element.style.opacity = "1";
    });
  }
});

})();